<div class="border d-flex flex-nowrap h-100 rounded w-100">
    <div class="side-bar d-flex flex-column border-end">
        <div class="header px-2 d-flex align-items-center">
            <span class="text-nowrap m-0">{{ userPageConfig?.tabTitle }} ({{ categoryTotal }})</span>
        </div>
        <div class="scroll-container d-flex flex-column border-top flex-grow-1">
            @for (category of categories; track category) {
                <div class="d-flex">
                    <div
                        class="option"
                        [class.active]="category === selectedCategory"
                        (click)="selectCategory(category)"
                    >
                        <span class="content">{{ category.categoryName }} ({{ category.savedItemList.length }})</span>
                    </div>
                    @if (!(selectedFilter === searchCategoryTypes.Favorite) && category.savedItemList.length === 0) {
                        <ws-ace-dropdown class="d-inline" size="small" icon="more-outline">
                            @for (option of categoryMenuOptions; track option) {
                                <button type="button" class="option" (click)="option.onClick(category)">
                                    <span class="content">{{ option.name }}</span>
                                </button>
                            }
                        </ws-ace-dropdown>
                    }
                </div>
            }
        </div>
    </div>
    <div class="d-flex flex-column w-100">
        <div class="scroll-container d-flex flex-column flex-grow-1">
            <table class="table">
                <thead>
                    @for (col of columns; track col) {
                        <th class="px-4 border-bottom ws-vertical-align-middle">
                            {{ col.name }}
                        </th>
                    }
                    <th class="border-bottom"></th>
                </thead>
                <tbody>
                    @for (row of selectedCategory?.savedItemList; track row; let i = $index) {
                        <tr (mouseenter)="hoveredRow = row" (mouseleave)="hoveredRow = null">
                            @for (col of columns; track col) {
                                <td
                                    (click)="selectRow(row)"
                                    class="px-4 py-0 border-0 ws-vertical-align-middle clickable"
                                >
                                    <div class="cell-contents d-flex align-items-center">
                                        @if (col.type === columnType.String) {
                                            <span>{{ row[col.key] }}</span>
                                        }
                                        @if (col.type === columnType.Date) {
                                            <span>{{ row[col.key] | weissmanDateFormat }}</span>
                                        }
                                    </div>
                                </td>
                            }
                            <td class="px-4 py-0 border-0">
                                <div class="row-actions">
                                    @if (row.canFavorite) {
                                        <ws-ace-button
                                            [iconFont]="row.isFavorite ? 'fa-solid fa-star' : 'fa-regular fa-star'"
                                            buttonStyle="text"
                                            state="action"
                                            size="small"
                                            [isDisabled]="hoveredRow !== row"
                                            (buttonClick)="toggleFavorite(row)"
                                        >
                                        </ws-ace-button>
                                    }
                                    @if (hasMenuOptions(selectedCategory, i, row)) {
                                        <ws-ace-dropdown
                                            class="d-inline"
                                            [icon]="!loadingRowMenu ? 'more-outline' : 'spinner'"
                                            size="small"
                                            [isLoading]="loadingRowMenu"
                                            [isDisabled]="hoveredRow !== row || loadingRowMenu"
                                            (openChange)="getMenuOptions($event, selectedCategory, i)"
                                        >
                                            @for (option of rowMenuOptions; track option) {
                                                @if (!option.isDisabled(row)) {
                                                    <button
                                                        type="button"
                                                        class="option"
                                                        (click)="option.onClick(row, selectedCategory.categoryType)"
                                                    >
                                                        <span class="content">{{ option.name }}</span>
                                                    </button>
                                                }
                                            }
                                        </ws-ace-dropdown>
                                    }
                                </div>
                            </td>
                        </tr>
                    }
                </tbody>
            </table>
        </div>
    </div>
</div>
